import React from 'react';

function Header() {
  return (
    <div className="header">
      <div className="name-badge">// ANUJ RATHORE //</div>
      <div className="title-wrapper">
        <h1 className="title">Coming Soon</h1>
        <span className="dots"></span>
      </div>
      <p className="subtitle">
        Data Science & AI Explorer | Building Intelligent Solutions
      </p>
    </div>
  );
}

export default Header;
